
import { i18nText } from '@/locales';
import {Form} from "@/form/form";
import {Component} from "vue-property-decorator";
import { VisitsCategoriesSettingsRequestType } from "./visits.types";
import {Validate} from "@/plugins/Vuelidate/Decorators";
import {maxLength, minLength, numeric, required} from "vuelidate/lib/validators";

@Component
export default class VisitsCategoriesForm extends Form {

    @Validate(required, i18nText("Введите назавание категории"))
    name: string | null = null;
    color: string | null = null;

    getFormData(): VisitsCategoriesSettingsRequestType {
       return{
            name: this.name,
            color: this.color,
       } 
    }

    setFormData(): void {}
}
